import React from "react";
import { ErrorContainer } from "./style";
import Button from "../../button";

export default props => {
  const retry = () => {
    if (props.request) {
      props.request();
    } else {
      window.location.reload();
    }
  };
  if (props.message) {
    return (
      <ErrorContainer borderless={props.borderless} inMiddle={props.inMiddle}>
        <i className="error-icon icon mapsa-notification " />
        <div className="error-message-container">{props.message}</div>
        <div className="action-container">
          <Button btn="error" onClick={() => retry()}>
            تلاش مجدد
          </Button>
        </div>
      </ErrorContainer>
    );
  } else {
    return null;
  }
};
